import { useNavigate } from "react-router-dom";
import { CreditCard } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function TrialBanner() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const state = user?.trial_state;
  const days = user?.trial_days_left ?? 0;

  if (!state || state === "none") return null;
  // Gesperrte Org-Zahler/Sub-Konten werden vom separaten Sperr-Banner (rot) abgedeckt.
  if (state === "expired" && user?.topup_blocked) return null;

  let bg = "bg-primary";
  let variant = "primary";
  let header = "SIE BEFINDEN SICH IM TESTMODUS";
  let message = `Sie können BeSca noch ${days} ${days === 1 ? "Tag" : "Tage"} kostenlos ausprobieren.`;

  if (state === "trial" && days <= 5) {
    bg = "bg-orange-500";
    variant = "orange";
    header = "DER TESTMODUS LÄUFT BALD AB";
  } else if (state === "expired") {
    bg = "bg-red-600";
    variant = "red";
    header = "DER TESTMODUS IST ABGELAUFEN";
    message = "Bitte starten Sie die Bezahlversion, um BeSca weiter zu nutzen.";
  }

  return (
    <div className={`${bg} text-white`} data-testid="trial-banner" data-variant={variant}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-between gap-3">
        <span className="text-sm min-w-0" data-testid="trial-banner-text">
          <strong className="font-bold" data-testid="trial-banner-header">
            {header}
          </strong>{" – "}
          {message}
        </span>
        <button
          type="button"
          onClick={() => navigate("/abo")}
          data-testid="trial-banner-cta"
          className="shrink-0 inline-flex items-center gap-2 rounded-md bg-white/15 hover:bg-white/25 px-3 py-1.5 text-sm font-semibold transition-colors"
        >
          <CreditCard className="h-4 w-4" /> Bezahlversion starten
        </button>
      </div>
    </div>
  );
}
